/* Twisted Mind Collective — homepage behavior (no dependencies) */
(function () {
  'use strict';
  if (window.__tmcHomeInit) return; /* sections may include this file more than once */
  window.__tmcHomeInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Scroll reveals */
    var revealEls = document.querySelectorAll('.tmc-rv');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* Toast */
    var toast = document.createElement('div');
    toast.className = 'tmc-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    var toastTimer;
    function showToast(html) {
      toast.innerHTML = html;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 4000);
    }

    /* Update the theme's header cart bubble (Dawn) after an AJAX add */
    function refreshCartBubble() {
      fetch('/?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-icon-bubble'];
          var holder = document.getElementById('cart-icon-bubble');
          if (html && holder) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.shopify-section') || doc.body;
            holder.innerHTML = inner.innerHTML;
          }
        })
        .catch(function () { /* non-critical */ });
    }

    /* Quick add — AJAX with graceful fallback to normal form POST */
    document.querySelectorAll('.tmc-qa-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* old browser: let the form POST to /cart/add */
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to bag'); });
            return r.json();
          })
          .then(function () {
            showToast('Added to bag ✓ <a href="/cart">View bag</a>');
            refreshCartBubble();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function (err) {
            showToast((err && err.message ? err.message : 'Could not add to bag') + ' <a href="/cart">View bag</a>');
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          });
      });
    });
  });
})();
